<template>
  <div>
    <div class="history_header">
      <div class="history_area tabs">
        <div class="tab" :class="{active: mode == 0}" @click="goToMarket">{{ t('未出品') }}</div>
        <div class="tab" :class="{active: mode == 1}" @click="change_page('market-mylist-display')">{{ t('出品待ち/出品中') }}</div>
        <div class="tab" :class="{active: mode == 2}" @click="change_page('market-mylist-soldout')">{{ t('完売') }}</div>
      </div>
      <div class="pending_area tabs">
        <div class="select-wrapper">
          <select class="select" v-model="card_type" @change="changeCardType">
            <option :value="null">{{ t('全タイトル') }}</option>
            <option
              v-for="item in decodedSelectType"
              :key="item.id"
              :value="item.id"
            >
            {{ t(item.name) }}
            </option>
          </select>
          <span class="arrow"></span>
        </div>
      </div>
    </div>
    <!-- <div class="history_header" v-if="mode !== 0">
      <div class="history_area tabs">
        <div class="tab" :class="{active: sale_type == 0}" @click="change_sale_type">{{ t('即決価格') }}</div>
        <div class="tab" :class="{active: sale_type == 1}" @click="change_sale_type">{{ t('オークション') }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  mixins: [t],
  data: () => ({
    sale_type: 0,
    mode: 0,
  }),

  props: {
    selectType: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    const url = window.location.href;
    if (url.includes('/market-mylist-display')) {
      this.mode = 1;
    } else if (url.includes('/market-mylist-soldout')) {
      this.mode = 2;
    } else {
      this.mode = 0;
    }
  },
  computed: {
    ...mapGetters('market', ['myListCardType']),
    card_type: {
      get() {
        return this.myListCardType;
      },
      set(value) {
        this.$store.dispatch('market/setMyListCardType', value);
      },
    },
    decodedSelectType() {
      const allowedIds = [1, 2, 3, 5, 7, 9];
      if (!this.selectType || !this.selectType.length) {
        return [];
      }
      return this.selectType
        .filter((item) => allowedIds.includes(item.id))
        .map((item) => ({
          id: item.id,
          name: item.name,
        }));
    },
  },

  methods: {
    goToMarket() {
      this.mode = 0;
      this.$router.push({ path: '/market-mylist-undecided' });
    },
    change_page(page) {
      this.$router.push({ path: `/${page}` });
    },
    change_sale_type() {
      this.sale_type = this.sale_type === 0 ? 1 : 0;
      this.$emit('changeSaleType', this.sale_type);
    },
    changeCardType() {
      this.$emit('changeCardType', this.card_type);
    },
  },
};
</script>

<style lang="scss" scoped>
.history_header {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  .tabs {
    background-color: #ffffff;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    .tab {
      padding: 5px 20px;
      border-radius: 10px;
      cursor: pointer;
      white-space: pre-wrap;
      color: #555;
      transition: all 0.2s ease-in-out;
    }
    .tab.active {
      background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
      color: #fff;
      box-shadow: 0 2px 8px rgba(42, 112, 184, 0.4);
    }
  }
  .history_area {
    width: 80%;
  }
  .pending_area {
    width: 15%;
    justify-content: center;
    .select-wrapper {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      .select {
        white-space: pre-wrap;
        width: 100%;
        height: 100%;
        padding: 5px 20px 5px 5px;
        border-radius: 10px;
        background-color: #ffffff;
        border: none;
        cursor: pointer;
        position: relative;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        appearance: none; // ブラウザのデフォルト矢印を消す
        -webkit-appearance: none;
        -moz-appearance: none;
        text-align: center;
      }
      .arrow {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 6px;
        height: 6px;
        pointer-events: none;
        border: solid black;
        border-width: 2px 2px 0 0;
        transform: translateY(-50%) rotate(135deg);
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .history_header {
    font-size: 11px;
    .tabs {
      padding: 1px;
      .tab {
        padding: 5px 7px;
      }
    }
    .history_area {
      width: 75%;
    }
    .pending_area {
      width: 23%;
    }
  }
}
</style>
